import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { observer } from 'mobx-react-lite'
import { gamificationStore } from '../stores/gamificationStore'

const LevelUpCelebration = observer(() => {
  const { t } = useTranslation()
  const [visible, setVisible] = useState(false)
  const [level, setLevel] = useState(1)

  useEffect(() => {
    if (gamificationStore.lastLevelUp > 0) {
      setLevel(gamificationStore.level)
      setVisible(true)
      const t = setTimeout(() => {
        setVisible(false)
        gamificationStore.clearLevelUpCelebration()
      }, 2800)
      return () => clearTimeout(t)
    }
  }, [gamificationStore.lastLevelUp])

  if (!visible) return null

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center pointer-events-none"
      aria-hidden
    >
      <div className="absolute inset-0 bg-black/30 transition-opacity duration-300 opacity-100" />
      <div className="relative z-10 flex flex-col items-center justify-center transition-all duration-300 scale-100">
        <div className="bg-gradient-to-br from-amber-400 via-orange-500 to-rose-500 rounded-3xl px-8 py-6 shadow-2xl border-2 border-white/40 text-white text-center min-w-[260px]">
          <p className="text-sm font-semibold uppercase tracking-wider opacity-90 mb-1">
            {t('levelUp.title')}
          </p>
          <p className="text-5xl font-bold drop-shadow-lg">{t('common.level')} {level}</p>
          <div className="flex justify-center gap-1 mt-3">
            {[0, 1, 2].map((i) => (
              <span
                key={i}
                className="w-2 h-2 rounded-full bg-white/80 animate-bounce"
                style={{ animationDelay: `${i * 150}ms` }}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  )
})

export default LevelUpCelebration
